// src/contexts/container.ts
import { createContext, useContext } from "react";
var ContainerContext = createContext({ element: null });
var useContainerContext = () => useContext(ContainerContext);

export {
  ContainerContext,
  useContainerContext
};
//# sourceMappingURL=chunk-HTJMMZVM.mjs.map